import PlaceholderModalView from "./PlaceholderModalView";

export default PlaceholderModalView;
